import { Spacing } from '@persona-id/design-tokens';
import { ComponentPropsWithoutRef, ReactNode } from 'react';
import styled from 'styled-components';

import { Paragraph } from 'design-system/components/Text';
import { paragraphMixins } from 'design-system/mixins/text';
import { BASE } from 'design-system/variables/spacing';

export interface TableCellProps {
  breakWord?: boolean;
  size?: 'sm' | 'md';
}

const TableCell = styled.td.attrs({ role: 'cell' })<TableCellProps>`
  display: table-cell;
  vertical-align: middle;

  border-bottom: 1px solid ${({ theme }) => theme.color.border.primary};
  text-align: left;
  padding: ${({ size }) => (size === 'sm' ? BASE : BASE * 1.5)}px;
  color: ${({ theme }) => theme.color.text.primary};
  white-space: nowrap;
  ${paragraphMixins.md};
  line-height: 1;
  ${({ breakWord }) =>
    breakWord
      ? `white-space: normal;
         overflow-wrap: break-word;`
      : ''}
`;

export default TableCell;

const CellTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const CellTitle = styled(Paragraph).attrs({ color: 'primary' })`
  display: flex;
  align-items: center;
  gap: ${Spacing[2]};
`;

interface TableCellTitleProps extends ComponentPropsWithoutRef<'div'> {
  subtitle?: ReactNode;
}

export const TableCellTitle = ({ children, subtitle, ...elemProps }: TableCellTitleProps) => {
  return (
    <CellTitleContainer {...elemProps}>
      <CellTitle>{children}</CellTitle>
      {subtitle && <Paragraph>{subtitle}</Paragraph>}
    </CellTitleContainer>
  );
};
